import React from "react";

const FilterIcon = () => {
  return <img src="./img/icon-filter-black.svg" alt="filter" className="icon-file" />;
};

export default FilterIcon;
